import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=0f634aa6"
import script from "./GroupCreate.vue?vue&type=script&lang=ts"
export * from "./GroupCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports